import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import { getSelectedPos } from 'reducers/PointsOfSale';
import { getWarehouseRights } from 'reducers/Login';
import { REDUX_WAREHOUSE, REDUX_WAREHOUSEID } from 'constants/persistence';
import * as warehousesActionTypes from 'constants/warehouses';
import { TYPE_LOGOUT, TYPE_LOGOUT_SOFT } from 'constants/Login';

const warehouses = (state = {}, action) => {
  switch (action.type) {
    case warehousesActionTypes.FETCH_SUCCESS:
      return Object.fromEntries(
        action.warehouses.map(wh => [wh.warehouseID, wh]),
      );
    case TYPE_LOGOUT:
    case TYPE_LOGOUT_SOFT:
      return {};
    default:
      return state;
  }
};

const fetching = (state = false, { type }) => {
  switch (type) {
    case warehousesActionTypes.FETCH_STARTED:
      return true;
    case warehousesActionTypes.FETCH_SUCCESS:
    case warehousesActionTypes.FETCH_FAILURE:
      return false;
    default:
      return state;
  }
};

const error = (state = null, { type, error }) => {
  switch (type) {
    case warehousesActionTypes.FETCH_FAILURE:
      return error;
    case warehousesActionTypes.FETCH_SUCCESS:
      return null;
    default:
      return state;
  }
};

export default combineReducers({ warehouses, fetching, error });

export const getAllWarehouses = createSelector(
  state => state.warehouses.warehouses,
  warehouses => Object.values(warehouses),
);

export const findWarehouseById = (state = [], id) => {
  return state[id] || null;
};

export const getWarehouseById = id => state =>
  findWarehouseById(state.warehouses.warehouses, id);

export const getAllowedWarehouses = createSelector(
  state => getAllWarehouses(state),
  state => getWarehouseRights(state),
  (allWarehouses, warehouseRights) => {
    const locations = [];
    warehouseRights.forEach(warehouse => {
      if (warehouse.right === '1') {
        const warehouseObj = allWarehouses.find(
          wh => Number(wh.warehouseID) === Number(warehouse.warehouseID),
        );
        warehouseObj &&
          warehouseObj?.isOfflineInventory === 0 &&
          locations.push(warehouseObj);
      }
    });
    return locations;
  },
);

const getStoredWarehouse = createSelector(
  () => localStorage.getItem(REDUX_WAREHOUSE),
  json => {
    try {
      return JSON.parse(json);
    } catch (e) {
      return null;
    }
  },
);

export const getSelectedWarehouseID = state =>
  JSON.parse(localStorage.getItem(REDUX_WAREHOUSEID));

export const getSelectedWarehouse = createSelector(
  state => getStoredWarehouse(state),
  state => getSelectedWarehouseID(state),
  state => getAllWarehouses(state),
  (stored, id, allWarehouses) => {
    const found =
      allWarehouses.find(warehouse => warehouse.warehouseID === id) || null;
    if (found) {
      localStorage.setItem(REDUX_WAREHOUSE, JSON.stringify(found));
      return found;
    }
    if (String(stored?.warehouseID) === String(id)) {
      return stored;
    }
    return null;
  },
);

export const getLoggedInWarehouse = state =>
  getWarehouseById(getSelectedPos(state)?.warehouseID)(state);

export function getIsFetchingWarehouses(state) {
  return state.warehouses.fetching;
}
